import { Fab, Fade, SvgIcon } from '@portal/common/components';
import theme, { styled } from '@portal/common/theme';

const Container = styled('div')(({ theme }) => ({
    position: 'absolute',
    right: -15,
    top: 140,
    zIndex: theme.zIndex.popovers,
}));

const fadeStyle = {
    zIndex: theme.zIndex.popovers,
};

const StyledIcon = styled(SvgIcon)<{ isMinimized: boolean }>(({ isMinimized }) => ({
    transform: isMinimized ? 'rotate(-90deg)' : 'rotate(90deg)',
}));

const MinimizeSidebarButton = ({ visible, minimized, onClick, ...props }) => {
    const handleClick = (event) => {
        onClick(event);
    };

    return (
        <Fade in={visible} style={fadeStyle}>
            <Container onClick={handleClick} {...props}>
                <Fab aria-label="Expand / Collapse">
                    <StyledIcon src="/icons/ic-arrow-down.svg" size="md" isMinimized={minimized} />
                </Fab>
            </Container>
        </Fade>
    );
};

export default MinimizeSidebarButton;
